import AddressFinderAutocompleteAPI from '@/app/apis/address-finder/address-finder-autocomplete/address-finder-autocomplete.js';

export default {
	/**
	 * @param {*} addressDetails
	 */
	async getAutocompleteAddress(addressDetails) {
		return AddressFinderAutocompleteAPI.getAutocompleteAddress(addressDetails);
	},
	
	/**
	 * @param {*} addressId
	 */
	async getAddressMetaData(addressId) {
		return AddressFinderAutocompleteAPI.getAddressMetaData(addressId);
	}
}